export const SUCCESS_PROPERTY="SUCCESS_PROPERTY";
export const FAILED_PROPERTY="FAILED_PROPERTY";
export const REQUST_PROPERTY="REQUST_PROPERTY";
